import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable, map } from 'rxjs'

@Injectable({ providedIn: 'root' })
export class GetCurrentVersionQuery {
  constructor(private httpClient: HttpClient) {}

  call(): Observable<string> {
    const url = `/last-version.json`

    return this.httpClient.get<{ version: string }>(url).pipe(map(({ version }) => version))
  }
}
